import type { Dispatch, SetStateAction } from 'react';
import classNames from 'classnames';

import { ActiveTabEnum, TabLabel } from '@models/in-person-booking';

import type { BookingTimeSlot } from './utils';
import TimeSlotsGrid from './TimeSlotsGrid';

const TAB_LABELS: TabLabel[] = [
  { id: ActiveTabEnum.MORNING, label: 'صبح' },
  { id: ActiveTabEnum.NOON, label: 'ظهر' },
  { id: ActiveTabEnum.NIGHT, label: 'شب' },
];

const TAB_TEST_IDS: Record<ActiveTabEnum, string> = {
  [ActiveTabEnum.MORNING]: 'healthcare-select-session-morning',
  [ActiveTabEnum.NOON]: 'healthcare-select-session-noon',
  [ActiveTabEnum.NIGHT]: 'healthcare-select-session-night',
};

type SessionTabsProps = {
  categorizedSlots: Record<ActiveTabEnum, BookingTimeSlot[]>;
  activeTab: ActiveTabEnum;
  setActiveTab: Dispatch<SetStateAction<ActiveTabEnum>>;
  selectedTimeSlot: BookingTimeSlot | null;
  setSelectedTimeSlot: Dispatch<SetStateAction<BookingTimeSlot | null>>;
};

const SessionTabs = ({
  categorizedSlots,
  activeTab,
  setActiveTab,
  selectedTimeSlot,
  setSelectedTimeSlot,
}: SessionTabsProps) => {
  const activeTabPosition = {
    [ActiveTabEnum.MORNING]: 'left-2/3',
    [ActiveTabEnum.NOON]: 'left-1/3',
    [ActiveTabEnum.NIGHT]: 'left-0',
  };

  return (
    <div className="flex flex-col gap-y-3">
      <div className="mx-4 overflow-x-auto overflow-y-hidden rounded-full bg-surface-secondary p-1 scrollbar-none">
        <ul className="relative flex w-full text-center text-Label/xSmall font-medium text-black">
          <div
            className={classNames(
              'absolute top-0 bottom-1 h-9 w-1/3 rounded-full bg-surface-primary shadow-fab transition-all duration-300',
              activeTabPosition[activeTab],
            )}
          />

          {TAB_LABELS.map((item) => (
            <li key={item.id} className="relative z-10 w-1/3">
              <button
                type="button"
                className="inline-flex w-full items-center justify-center gap-1 p-1 text-nowrap text-Label/Medium transition-all"
                onClick={() => setActiveTab(item.id)}
                data-testid={TAB_TEST_IDS[item.id]}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <TimeSlotsGrid
        slots={categorizedSlots[activeTab]}
        activeTabLabel={TAB_LABELS[activeTab]?.label}
        selectedTimeSlot={selectedTimeSlot}
        setSelectedTimeSlot={setSelectedTimeSlot}
      />
    </div>
  );
};

export default SessionTabs;
